// Libraries.
import { all, call } from 'redux-saga/effects'

/**
 * Functionality saga for "update webrtc log level" actions.
 * @method updateLogLevel
 * @param  {Object} webRTC The WebRTC stack.
 * @param  {Object} action A "log level change" action.
 */
export function * updateLogLevel (webRTC, action) {
  // If the WebRTC log level was changed, update the WebRTC stack's loggers.
  if (action.payload.WEBRTC) {
    yield call([webRTC.logs, 'setLevel'], action.payload.WEBRTC)
    const loggers = yield call([webRTC.logs, 'getLoggers'])

    yield all(loggers.map(logger => call([logger, 'setLevel'], action.payload.WEBRTC)))
  }
}

/**
 * Functionality saga for "update webrtc log handler" actions.
 * @method updateLogHandler
 * @param  {Object} webRTC The WebRTC stack.
 * @param  {Object} action A "log handler change" action.
 */
export function * updateLogHandler (webRTC, action) {
  // If the WebRTC log handler was changed, update the WebRTC stack's loggers.
  if (action.payload.WEBRTC) {
    yield call([webRTC.logs, 'setHandler'], action.payload.WEBRTC)
    const loggers = yield call([webRTC.logs, 'getLoggers'])

    yield all(loggers.map(logger => call([logger, 'setHandler'], action.payload.WEBRTC)))
  }
}
